export const toMindbodyMemberProfileImageUrl = (businessName?: string, memberUniqueId?: string) =>
  businessName && memberUniqueId
    ? `https://clients-content.mindbodyonline.com/studios/${businessName}/clients/${memberUniqueId}_large.jpg`
    : '';
